export const roles = '/roles';
export const module = '/roles/modules';
export const addRole = '/roles';
